import { useState } from "react";
import UrlInputComponent from "./urlInput.component";

export default function UrlInputContainer({
  urlInput,
  setUrlInput,
  onValidate, // connect to API
  onFieldChange,
  isValidating,
  urlError: parentUrlError,
  setUrlError: parentSetUrlError,
}) {
  const [localUrlError, setLocalUrlError] = useState("");

  const urlError = parentUrlError !== undefined ? parentUrlError : localUrlError;
  const setUrlError = parentSetUrlError !== undefined ? parentSetUrlError : setLocalUrlError;

  const isValidUrl = (urlString) => {
    try {
      const url = new URL(urlString);
      return url.protocol === "http:" || url.protocol === "https:";
    } catch {
      return false;
    }
  };

  const handleValidateClick = () => {
    const urls = urlInput
      .split("\n")
      .map((url) => url.trim())
      .filter((url) => url.length > 0);

    const invalidUrls = urls.filter((url) => !isValidUrl(url));

    if (invalidUrls.length > 0) {
      setUrlError(
        `Invalid URL format detected (${invalidUrls.length} URL${invalidUrls.length > 1 ? "s" : ""}). Please enter valid HTTP/HTTPS URLs.`
      );
      return;
    }

    setUrlError("");
    if (urlInput.trim()) {
      onValidate();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const paste = e.clipboardData.getData("text");
    const pastedUrls = paste
      .split("\n")
      .map((url) => url.trim())
      .filter((url) => url.length > 0);
    const currentUrls = urlInput
      .split("\n")
      .map((url) => url.trim())
      .filter((url) => url.length > 0);

    const allUrls = [...currentUrls, ...pastedUrls];
    if (allUrls.length > 100) {
      setUrlError("You can only input up to 100 URLs at a time.");
      return;
    }
    setUrlInput(allUrls.join("\n"));
    if (urlError) {
      setUrlError("");
    }
    if (onFieldChange) {
      onFieldChange();
    }
  };

  const handleInputChange = (e) => {
    const { value } = e.target;

    const urls = value
      .split("\n")
      .map((url) => url.trim())
      .filter((url) => url.length > 0);

    if (urls.length > 100) {
      setUrlError("You can only input up to 100 URLs at a time.");
      setUrlInput(value);
      return;
    }

    setUrlInput(value);

    if (urlError) {
      setUrlError("");
    }
    if (onFieldChange) {
      onFieldChange();
    }
  };

  const urls = urlInput
    .split("\n")
    .map((url) => url.trim())
    .filter((url) => url.length > 0);

  const isValidateDisabled = isValidating || urls.length === 0 || !urls.every(isValidUrl);

  return (
    <UrlInputComponent
      urlInput={urlInput}
      urlError={urlError}
      isValidating={isValidating}
      isValidateDisabled={isValidateDisabled}
      handleInputChange={handleInputChange}
      handleValidateClick={handleValidateClick}
      handlePaste={handlePaste}
    />
  );
}
